import axios from "axios";
import moment from "moment-timezone";

import { history } from "pixacomHistory";
import storage from "components/Pixacom/storage";

const ONE_MINUTE_MS = 60000;
const REFRESH_BEFORE_EXPIRATION_MS = 10 * 60 * 1000;
const LOGOUT_INACTIVITY_THIRTY_MIN_MS = 30 * 60 * 1000;

const LAST_ACTIVITY_KEY = "lastActivity";
const ACTIVITY_WRITE_THROTTLE_MS = 5000;

const INACTIVITY_EVENTS = [
  "load",
  "mousemove",
  "mousedown",
  "touchstart",
  "touchmove",
  "click",
  "keydown",
  "input",
  "scroll",
  "wheel",
];

let inactivityInterval = null;
let tokenExpirationTimeout = null;
let lastActivityWrite = 0;

const plainAxios = axios.create();

function onSuccessfulAuth(token, expiration, resetActivity = true) {
  storage.setItem("token", token);
  storage.setItem("expiration", expiration);

  if (resetActivity) {
    updateLastActivity(true);
  }

  setupInactivityLogoutListeners();

  const [, expiresIn] = getExpirationData(expiration);
  startNewLogoutExpirationTimeout(expiresIn);
}

function tryRefreshToken(fallback) {
  console.log("[AUTH][REFRESH] Spouštím refresh tokenu", {
    now: new Date().toLocaleTimeString(),
    expiration: storage.getItem("expiration"),
    lastActivity: storage.getItem(LAST_ACTIVITY_KEY)
      ? new Date(storage.getItem(LAST_ACTIVITY_KEY)).toLocaleTimeString()
      : null,
  });

  plainAxios
    .post(
      "/api/auth/refreshtoken",
      {},
      {
        headers: { Authorization: `Bearer ${storage.getItem("token")}` },
      }
    )
    .then(({ data: { token, expiration } = {} }) => {
      if (token && expiration) {
        onSuccessfulAuth(token, expiration, false);
      } else {
        fallback();
      }
    })
    .catch((err) => {
      console.error("[REFRESH FAILED]", err?.response?.status, err?.response?.data);
      fallback();
    });
}

function isInactive() {
  const lastActivity = storage.getItem(LAST_ACTIVITY_KEY);

  if (!lastActivity) {
    return false;
  }

  return (
    Date.now() - lastActivity >=
    LOGOUT_INACTIVITY_THIRTY_MIN_MS
  );
}

const handleTokenExpiration = () => {
  if (isInactive()) {
    handleLogout("User logged out due to inactivity.");
    return;
  }

  tryRefreshToken(() =>
    handleLogout("User logged out due to token expiration.")
  );
};

function startNewLogoutExpirationTimeout(time) {
  if (tokenExpirationTimeout) {
    clearTimeout(tokenExpirationTimeout);
  }

  const delay = Math.max(time - REFRESH_BEFORE_EXPIRATION_MS, ONE_MINUTE_MS);

  tokenExpirationTimeout = setTimeout(handleTokenExpiration, delay);
}

function getExpirationData(expiration) {
  const storageExpiration = storage.getItem("expiration");
  const diff = moment(expiration || storageExpiration).diff(moment());

  return [expiration || storageExpiration, diff];
}

export const loginWithMicrosoft = (token, expiration, userId) => {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/user/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const user = response.data;

      onSuccessfulAuth(token, expiration);

      dispatch({
        type: "LOGIN_WITH_EMAIL",
        payload: {
          success: true,
          token,
          expiration,
          user,
        },
      });

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };
};

export const loginWithEmail =
  ({ email, password }) =>
  async (dispatch) => {
    dispatch({
      type: "LOGIN_WITH_EMAIL",
      payload: { success: null, message: null },
    });
    
    return axios
      .post("/api/auth/login", {
        username: email,
        password: password,
      })
      .then(({ data }) => {
        if (data) {
          console.info("[LOGGED IN ON]", new Date());
          const { token, expiration, user, requiresTwoFactor } = data || {};

          if (requiresTwoFactor) {
            dispatch({
              type: "LOGIN_TWO_FACTOR",
              payload: { success: true /*, user: user*/ },
            });
            history.push("/VerifyCode");
          } else {
            //AuthStore.setToken(token);

            onSuccessfulAuth(token, expiration);

            dispatch({
              type: "LOGIN_WITH_EMAIL",
              payload: {
                success: true,
                /*userRole: "admin",*/ token,
                expiration,
                user,
              }, // TODO - user one role, enablo to change roles (if have more)
            });

            const returnPath =
              history?.location?.state?.pathname &&
              history.location.state.pathname !== "/login"
                ? history.location.state.pathname +
                  (history.location.state.search || "")
                : "/";

            window.location.replace(returnPath);

            // window.location.reload();
          }
        }
      })
      .catch((error) => {
        const { response, request } = error;
        let message = "error";

        if (response) {
          // client received an error response (5xx, 4xx)
          const data = response.data;

          message =
            data?.error_description ||
            data?.detail ||
            data?.title ||
            data?.general?.[0] ||
            data?.errors?.password?.[0] ||
            (typeof data === "string" ? data : `Chyba ${response.status}`);
        } else if (request) {
          message = "Network error. Please try again.";
        } else {
          message = error.message || "Chyba při odesílání požadavku.";
        }

        dispatch({
          type: "LOGIN_WITH_EMAIL",
          payload: {
            message,
            success: false,
          },
        });
      });
    };

export const loginWithIp = () => {
  return async (dispatch) => {
    await axios
      .get("/api/auth/LoginAsIp", null)
      .then(({ data }) => {
        if (data) {
          const token = data.token;
          const expiration = data.expiration;
          const user = data.user;
          // const requiresTwoFactor = data.requiresTwoFactor;

          //AuthStore.setToken(token);
          onSuccessfulAuth(token, expiration);

          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              success: true,
              /*userRole: "admin",*/ token,
              expiration,
              user,
            }, // TODO - user one role, enablo to change roles (if have more)
          });
          window.location.replace("/");
          // window.location.reload();
        }
      })
      .catch((err) => {
        if (err.response) {
          // client received an error response (5xx, 4xx)
          var errorMsg = "";
          if (err.response.data.error_description)
            errorMsg = err.response.data.error_description;
          if (err.response.data.general)
            errorMsg = err.response.data.general[0];
          if (err.response.data.errors)
            errorMsg = err.response.data.errors.password[0];
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: errorMsg,
              success: false,
            },
          });
        } else if (err.request) {
          // client never received a response, or request never left
        } else {
          // anything else
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: "error",
              success: false,
            },
          });
        }

        return false;
      });
  };
};

export const loginSwitchUser = (user) => {
  return async (dispatch) => {
    var token = storage.getItem("token");
    var config = { headers: { Authorization: `Bearer ${token}` } };

    await axios
      .get("/api/Auth/SwitchUser/" + user, {
        headers: { Authorization: `Bearer ${storage.getItem("token")}` },
      })
      .then((response) => {
        if (response.data) {
          const token = response.data.token;
          const expiration = response.data.expiration;
          const user = response.data.user;

          onSuccessfulAuth(token, expiration);

          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              success: true,
              /*userRole: "admin",*/ token,
              expiration,
              user,
            }, // TODO - user one role, enablo to change roles (if have more)
          });

          axios
            .get("/api/Activity/Last/" + user.personID, config)
            .then((response) => {
              if (response.status === 200 || response.status === 204) {
                let object = {
                  id: response.data.id,
                  activityType: response.data.activityType,
                  begin: response.data.begin,
                  end: response.data.end,
                  time: response.data.time,
                  taskID: response.data.taskID,
                  task: response.data.task,
                  activityInterruptionType:
                    response.data.activityInterruptionType,
                  activityInterruptionTypeID:
                    response.data.activityInterruptionTypeID,
                  feature: response.data.feature,
                };

                if (response.data.activityType === 0) {
                  dispatch({
                    type: "ACTIVITY_ARRIVAL",
                    payload: { lastActivity: object },
                  });
                } else if (response.data.activityType === 1) {
                  dispatch({
                    type: "ACTIVITY_DEPARTURE",
                    payload: { lastActivity: object },
                  });
                } else if (response.data.activityType === 2) {
                  dispatch({
                    type: "ACTIVITY_INTERRUPTION",
                    payload: { lastActivity: object },
                  });
                } else if (response.data.activityType === 3) {
                  dispatch({
                    type: "ACTIVITY_WORK",
                    payload: { lastActivity: object },
                  });
                }
              } else {
                console.error("Chyba při načítání dat ze serveru!");
              }
            })
            .catch((err) => console.error("Nastala chyba: " + err));

          history.push("/");
        }
      })
      .catch((err) => {
        if (err.response) {
          // client received an error response (5xx, 4xx)
          var errorMsg = "";
          if (err.response.data.error_description)
            errorMsg = err.response.data.error_description;
          if (err.response.data.general)
            errorMsg = err.response.data.general[0];
          if (err.response.data.errors)
            errorMsg = err.response.data.errors.password[0];
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: errorMsg,
              success: false,
            },
          });
        } else if (err.request) {
          // client never received a response, or request never left
        } else {
          // anything else
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: "error",
              success: false,
            },
          });
        }
      });
  };
};

export const LoginResendCode = () => {
  return async (dispatch) => {
    await axios
      .post("/api/auth/loginresendcode", {
        /*username: user.email,
        password: ''*/
      })
      .then((response) => {})
      .catch((err) => {
        if (err.response) {
          // client received an error response (5xx, 4xx)
          var errorMsg = "";
          if (err.response.data.error_description)
            errorMsg = err.response.data.error_description;
          if (err.response.data.general)
            errorMsg = err.response.data.general[0];
          if (err.response.data.errors)
            errorMsg = err.response.data.errors.password[0];
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: errorMsg,
              success: false,
            },
          });
        } else if (err.request) {
          // client never received a response, or request never left
        } else {
          // anything else
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: "error",
              success: false,
            },
          });
        }
      });
  };
};

export const LoginVerifyCode = (code) => {
  return async (dispatch) => {
    await axios
      .post("/api/auth/loginverifycode", {
        //UserName: user.email,
        TwoFactorCode: code,
      })
      .then((response) => {
        if (response.data) {
          const token = response.data.token;
          const expiration = response.data.expiration;
          const user = response.data.user;

          onSuccessfulAuth(token, expiration);

          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              success: true,
              /*userRole: "admin",*/ token,
              expiration,
              user,
            }, // TODO - user one role, enablo to change roles (if have more)
          });
          window.location.replace("/");
        }
      })
      .catch((err) => {
        if (err.response) {
          // client received an error response (5xx, 4xx)
          var errorMsg = "";
          if (err.response.data.error_description)
            errorMsg = err.response.data.error_description;
          if (err.response.data.general)
            errorMsg = err.response.data.general[0];
          if (err.response.data.errors)
            errorMsg = err.response.data.errors.password[0];
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: errorMsg,
              success: false,
            },
          });
        } else if (err.request) {
          // client never received a response, or request never left
        } else {
          // anything else
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: "error",
              success: false,
            },
          });
        }
      });
  };
};

export const logoutWithEmail = () => {
  return async (dispatch) => {
    await axios.post(
      "/api/auth/logout",
      {},
      { headers: { Authorization: `Bearer ${storage.getItem("token")}` } }
    );

    dispatch({ type: "LOGOUT_WITH_EMAIL", payload: {} });
    handleLogout("User logged out manually.");
  };
};

export const logoutWithoutEmail = () => async (dispatch) => {
  dispatch({ type: "LOGOUT_WITHOUT_EMAIL", payload: {} });
  handleLogout("User logged out without email.");
};

export const handleLogout = (message) => {
  console.warn(`[LOGOUT] ${message}`, {
    now: new Date().toISOString(),
    expiration: storage.getItem("expiration"),
    lastActivity: storage.getItem(LAST_ACTIVITY_KEY),
    currentPath: history.location.pathname,
  });

  storage.removeItem("token");
  storage.removeItem("expiration");
  storage.removeItem("user");
  storage.removeItem("userRole");
  storage.removeItem(LAST_ACTIVITY_KEY);

  if (inactivityInterval) {
    clearInterval(inactivityInterval);
    inactivityInterval = null;
  }

  INACTIVITY_EVENTS.forEach((event) => {
    window.removeEventListener(event, handleUserActivity, true);
  });

  window.removeEventListener("focus", handleWindowFocus);

  document.removeEventListener(
    "visibilitychange",
    handleVisibilityChange
  );

  window.removeEventListener("storage", handleStorageChange);

  if (tokenExpirationTimeout) {
    clearTimeout(tokenExpirationTimeout);
    tokenExpirationTimeout = null;
  }

  history.push({
    pathname: "/login",
    state: {
      pathname: history.location.pathname,
      search: history.location.search,
    },
  });
};

export const changeRole = (role) => {
  return (dispatch) => dispatch({ type: "CHANGE_ROLE", userRole: role });
};

export const changeUser = (user) => {
  return (dispatch) => dispatch({ type: "CHANGE_USER", user: user });
};

export const changePassword = (object) => {
  return async (dispatch) => {
    await axios
      .post(
        "/api/auth/changepassword",
        { OldPass: object.oldpass, NewPass: object.newpass },
        {
          headers: { Authorization: `Bearer ${storage.getItem("token")}` },
        }
      )
      .then((response) => {
        dispatch({ type: "CHANGE_PASSWORD", payload: { success: true } });
      })
      .catch((err) => {
        if (err.response) {
          var errorMsg = "";
          if (err.response.data.error_description)
            errorMsg = err.response.data.error_description;
          dispatch({
            type: "CHANGE_PASSWORD",
            payload: { message: errorMsg, success: false },
          });
        } else {
          dispatch({
            type: "CHANGE_PASSWORD",
            payload: { message: "error", success: false },
          });
        }
      });
  };
};

function updateLastActivity(force = false) {
  const now = Date.now();

  if (!force && now - lastActivityWrite < ACTIVITY_WRITE_THROTTLE_MS) {
    return;
  }

  lastActivityWrite = now;
  storage.setItem(LAST_ACTIVITY_KEY, now);
}

function handleUserActivity() {
  const token = storage.getItem("token");

  if (!token) {
    return;
  }

  updateLastActivity(false);
}

function checkInactivity() {
  const token = storage.getItem("token");

  if (!token) {
    console.log("[AUTH][INACTIVITY] Kontrola přeskočena - uživatel nemá token.");
    return;
  }

  const lastActivity = storage.getItem(LAST_ACTIVITY_KEY);

  if (!lastActivity) {
    console.log(
      "[AUTH][INACTIVITY] lastActivity neexistuje, nastavuji aktuální čas."
    );

    updateLastActivity(true);
    return;
  }

  const now = Date.now();
  const inactiveFor = now - lastActivity;

  if (inactiveFor >= LOGOUT_INACTIVITY_THIRTY_MIN_MS) {
    console.warn(
      "[AUTH][INACTIVITY] Limit neaktivity překročen - provádím logout."
    );

    handleLogout("User logged out due to inactivity.");
  }
}

function handleWindowFocus() {
  checkInactivity();
}

function handleVisibilityChange() {
  if (!document.hidden) {
    checkInactivity();
  }
}

function handleStorageChange(event) {
  if (event.key === "token" && event.newValue === null) {
    console.warn(
      "[AUTH][STORAGE] Token byl odstraněn v jiném tabu/okně - odhlašuji i toto okno."
    );

    handleLogout("User logged out in another tab/window.");
  }
}


function setupInactivityLogoutListeners() {
  // Pro jistotu nejprve odstraníme původní listenery
  INACTIVITY_EVENTS.forEach((event) => {
    window.removeEventListener(event, handleUserActivity, true);
  });

  window.removeEventListener("focus", handleWindowFocus);

  document.removeEventListener(
    "visibilitychange",
    handleVisibilityChange
  );

  // Přidáme listenery skutečné aktivity
  INACTIVITY_EVENTS.forEach((event) => {
    window.addEventListener(event, handleUserActivity, true);
  });

  // focus/visibilitychange pouze kontrolují stav
  window.addEventListener("focus", handleWindowFocus);

  document.addEventListener(
    "visibilitychange",
    handleVisibilityChange
  );

  window.removeEventListener("storage", handleStorageChange);
  window.addEventListener("storage", handleStorageChange);

  // Zrušit předchozí interval
  if (inactivityInterval) {
    clearInterval(inactivityInterval);
  }

  // Kontrola každou minutu
  inactivityInterval = setInterval(() => {
    checkInactivity();
  }, ONE_MINUTE_MS);

  // A jedna kontrola ihned
  checkInactivity();
}

function initialSetup() {
  const token = storage.getItem("token");
  const expiration = storage.getItem("expiration");

  if (token && expiration) {
    // Po nasazení nové verze mohou už existovat přihlášení uživatelé,
    // kteří ještě lastActivity v localStorage nemají.
    if (!storage.getItem(LAST_ACTIVITY_KEY)) {
      updateLastActivity(true);
    }

    setupInactivityLogoutListeners();

    const [, expiresIn] = getExpirationData();

    if (expiresIn > REFRESH_BEFORE_EXPIRATION_MS) {
      startNewLogoutExpirationTimeout(expiresIn);
    } else {
      handleTokenExpiration();
    }

    return;
  }

  const url = new URL(window.location.href);
  const urlToken = url.searchParams.get("token");

  const isLoginPage = history.location.pathname === "/login";

  if (!urlToken && !isLoginPage) {
    history.push({
      pathname: "/login",
      state: {
        pathname: history.location.pathname,
        search: history.location.search,
      },
    });
  }
}

// --- 401 -> refresh + retry
if (!window.__PIX_AXIOS_401_INTERCEPTOR__) {
  window.__PIX_AXIOS_401_INTERCEPTOR__ = true;

  let isRefreshing = false;
  let refreshQueue = [];

  const enqueue = () =>
    new Promise((resolve, reject) => refreshQueue.push({ resolve, reject }));

  const flushQueue = (err, token) => {
    refreshQueue.forEach((p) => (err ? p.reject(err) : p.resolve(token)));
    refreshQueue = [];
  };

  const refreshTokenPromise = () =>
    new Promise((resolve, reject) => {
      const oldToken = storage.getItem("token");
      const oldExpiration = storage.getItem("expiration");
      let done = false;

      tryRefreshToken(() => {
        if (!done) {
          done = true;
          reject(new Error("Refresh failed"));
        }
      });

      const start = Date.now();
      const check = () => {
        const t = storage.getItem("token");
        const e = storage.getItem("expiration");

        const tokenChanged = t && t !== oldToken;
        const expirationChanged = e && e !== oldExpiration;

        if (!done && t && e && (tokenChanged || expirationChanged)) {
          done = true;
          return resolve(t);
        }

        if (!done && Date.now() - start > 5000) {
          done = true;
          return reject(new Error("Refresh timeout"));
        }

        setTimeout(check, 100);
      };

      check();
    });

    axios.interceptors.response.use(
      (res) => res,
      async (error) => {
        const status = error?.response?.status;
        const cfg = error?.config || {};
        const url = cfg?.url || "";

        if (status !== 401) return Promise.reject(error);

        // --- endpointy kde NIKDY nespouštět refresh
        const skipRefresh = [
          "/api/auth/login",
          "/api/auth/logout",
          "/api/auth/loginverifycode",
          "/api/auth/loginresendcode",
          "/api/auth/refreshtoken",
        ].some((p) => url.includes(p));

        // pokud není 401 nebo je endpoint ve skip listu -> pošli error dál
        if (status !== 401 || skipRefresh) {
          return Promise.reject(error);
        }

        // ochrana proti smyčce
        if (cfg.__isRetryRequest) {
          handleLogout("User logged out due to repeated 401.");
          return Promise.reject(error);
        }

        // pokud refresh už běží, počkej
        if (isRefreshing) {
          try {
            const newToken = await enqueue();
            cfg.__isRetryRequest = true;
            cfg.headers = cfg.headers || {};
            cfg.headers.Authorization = `Bearer ${newToken}`;
            return axios(cfg);
          } catch (e) {
            handleLogout("User logged out due to refresh wait failure.");
            return Promise.reject(error);
          }
        }

        // spusť refresh
        isRefreshing = true;

        try {
          const newToken = await refreshTokenPromise();
          isRefreshing = false;
          flushQueue(null, newToken);

          cfg.__isRetryRequest = true;
          cfg.headers = cfg.headers || {};
          cfg.headers.Authorization = `Bearer ${newToken}`;

          return axios(cfg);
        } catch (e) {
          isRefreshing = false;
          flushQueue(e, null);
          handleLogout("User logged out due to token refresh failure.");
          return Promise.reject(error);
        }
      }
    );
}

initialSetup();
